import { render, staticRenderFns } from "./StudentInformationTeaching.vue?vue&type=template&id=719a414f&scoped=true&lang=pug&"
import script from "./StudentInformationTeaching.vue?vue&type=script&lang=ts&"
export * from "./StudentInformationTeaching.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformationTeaching.vue?vue&type=style&index=0&id=719a414f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719a414f",
  null
  
)

export default component.exports